// Use a closure to isolate
(function(jQuery){
  
  var loadScript = function(url, callback){

  	/* JavaScript that will load the jQuery library on Google's CDN.
     We recommend this code: http://snipplr.com/view/18756/loadscript/.
     Once the jQuery library is loaded, the function passed as argument,
     callback, will be executed. */
    
  	var script = document.createElement("script")
    script.type = "text/javascript";
 
    if (script.readyState){  //IE
        script.onreadystatechange = function(){
            if (script.readyState == "loaded" ||
                    script.readyState == "complete"){
                script.onreadystatechange = null;
                callback();
            }
        };
    } else {  //Others
        script.onload = function(){
            callback();
        };
    }
 
    script.src = url;
    // Add script to head tag
    document.getElementsByTagName("head")[0].appendChild(script);

  };

  var extendInfiniteOptions = function($){

    var dobFieldName = 'properties[pupil_dob]';
    var dobField = "[name='" + dobFieldName + "']"
    
    // Make readonly
    $(dobField).attr('readOnly', 'true');

    // Add a datepicker
    // First get variables from description
    var startDate = '';
    var minYears = 0;
    var maxYears = 0;
    var descOkay = false;

    var proddesc = $("[itemprop='description']").html();
    console.log(proddesc);
    
    var sdMatch = proddesc.match(/Start.*?(Date|Week).*?\:(\s+|\&nbsp\;)(\d{2}\/\d{2}\/\d{4})/i);
    console.log(sdMatch);
    
    if (sdMatch) {
      startDate = sdMatch[3];
      
      var ageMatch = proddesc.match(/Age(s)*\:\s+(\S+)(\s+|\&nbsp\;)\-\s+(\S+)\s+/i);
      console.log(ageMatch);
      
      if (ageMatch) {
        minYears = parseFloat(ageMatch[2]);
        maxYears = parseFloat(ageMatch[4]);
        descOkay = true;
      }
      else {
        ageMatch = proddesc.match(/Age(s)*\:\s+(\d+)(\s+|\&nbsp\;)/i);
        if (ageMatch) {
          minYears = parseFloat(ageMatch[2]);
          maxYears = minYears + 1;
          descOkay = true;
        }
        else {
          ageMatch = proddesc.match(/Age(s)*\:\s+(\d+)\+/i);
          if (ageMatch) {
            minYears = parseFloat(ageMatch[2]);
            maxYears = 99;
            descOkay = true;
          }
        }
      }
    }

    if (descOkay) {
      var dtStartDate = new Date( startDate.replace( /(\d{2})\/(\d{2})\/(\d{4})/, "$3-$2-$1") );
      var minDate = moment(dtStartDate).subtract(maxYears, 'years').add(1, 'day');
      var maxDate = moment(dtStartDate).subtract(minYears, 'years');
      var yearsHalfway = ((maxYears - minYears)/2);
      var defaultDate = maxYears == 99 ? moment(dtStartDate).subtract(minYears, 'years').add(1, 'day') : moment(minDate).add(yearsHalfway, 'years');

      $(dobField).datepicker( {
          dateFormat: 'dd/mm/yy',
          defaultDate: defaultDate.format('DD/MM/YYYY'),
          minDate: minDate.format('DD/MM/YYYY'),
          maxDate: maxDate.format('DD/MM/YYYY'),
          /*beforeShow: function(){    
               $(".ui-datepicker").css('font-size', 12);
               $(".ui-datepicker").css('padding', '10px'); 
               $(".ui-datepicker").css('width', '60px'); 
          },*/
          onClose: function(){
            var dob = $(dobField).datepicker( "getDate" );
            /*var monthsDiff = moment(dtStartDate).diff(moment(dob), 'months', true);
            if (monthsDiff < minYears*12 || monthsDiff > maxYears * 12) {
              alert('Class is for children between ' + minYears + ' and ' + maxYears + ' on ' + startDate + '.');
              $(dobField).val('');  
            }*/
          }
        }
      );
      var currField = $("input:focus");
      if (currField[0].name === dobFieldName) { 
      	$(dobField).datepicker("show");
      }
    }
    else {
      $(dobField).css("color","red");
      $(dobField).val('Product Error');
    }

  };

  // If we click on the Infinite Options div, then attach the datepicker
  // Cannot do it beforehand as Infinite Options is not loaded
  $('#infiniteoptions-container').on('click', function(evt) {
    
    var dpclass = $("[name='properties[pupil_dob]']").attr('class');
    // Datepicker adds a class when it is loaded
    if (dpclass.indexOf("hasDatepicker") === -1)
    {
      	var url = 'https://ajax.googleapis.com/ajax/libs/jqueryui/1.12.1/jquery-ui.min.js';
        loadScript(url, function(){
          
    			extendInfiniteOptions(jQuery);
  			}
    	);
    }
    
  });
  
})(jQuery);